<template>
  <div class="circle_icon" :title="title">
    <img :src="src" style="width: 40px; height: 40px" />
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: "ic_zhidongqiya.png",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    src() {
      return require("@/assets/images/" + this.icon + "");
    },
  },
  methods: {},
};
</script>
<style scoped>
.circle_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border: 4px solid #46609a;
  border-radius: 50%;
}
</style>
